import dayjs from 'dayjs';

import {
  ACTIVITY_GROUP_BY_TYPES_MAP,
  ACTIVITY_AGGREGATION_LEVELS_MAP,
  ACTIVITY_CRITICAL_TYPES_MAP,
  ACTIVITY_DISPLAY_TYPES_MAP,
} from 'business/shift-report/report-analyze/pages/activity-analyze/types';

import { ActivityAnalyzeRangeFilters } from './types';

export const defaultFiltersNoDate = {
  filterType: 'date',
  dateRange: [null, null],
  groupByType: ACTIVITY_GROUP_BY_TYPES_MAP.day,
  aggregationLevel: ACTIVITY_AGGREGATION_LEVELS_MAP[1],
  criticalType: ACTIVITY_CRITICAL_TYPES_MAP.all,
  vChartScale: null,
  displayType: ACTIVITY_DISPLAY_TYPES_MAP.bar,
} satisfies ActivityAnalyzeRangeFilters;

export const getDefaultFilters = () =>
  ({
    ...defaultFiltersNoDate,
    dateRange: [dayjs().subtract(6, 'day'), dayjs()],
  }) satisfies ActivityAnalyzeRangeFilters;
